module.exports = __webpack_public_path__ + "img/1.97bf5ae9.png";